module.exports = __webpack_public_path__ + "images/embed/icon_call.png";